import { FatalError } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export class FatalCycleError extends FatalError {
  static override locales: Locales = {
    'en-US': 'Cycle detected %s',
    'zh-CN': '循环错误 %s',
    'zh-HK': '循環錯誤 %s'
  }

  override name = 'FatalCycleError' as const

  constructor(key = 'anonymous') {
    super(key)
  }
}
